import type {SinceSelector} from '../../../routes/route-payload-types'
import {useOverviewStore} from '../../../stores/OverviewStore'

import {useOverviewRouteData} from './use-overview-route-data'

export function useEffectiveSelection() {
  const {sinceSelectors, lastActivityTimestamp} = useOverviewRouteData()
  const userSelection = useOverviewStore(state => state.userSelection)
  const setUserSelection = useOverviewStore(state => state.overviewStoreActions.setUserSelection)

  const handleSelect = (since: SinceSelector) => setUserSelection(since.source)

  const serverSelected = sinceSelectors.find(s => s.selected) ?? sinceSelectors[0] ?? null

  const effectiveSelection =
    (userSelection !== null ? sinceSelectors.find(s => s.source === userSelection) : null) ?? serverSelected

  return {effectiveSelection, sinceSelectors, lastActivityTimestamp, handleSelect}
}
